import React from 'react';
import PropTypes from 'prop-types';
import { Description, Title } from '~/compositions/common';

export default function ConfirmBlock({ cardNumber }) {
  return (
    <>
      <Title marginBottom="20px">Bloquear cartão</Title>
      <Description>
        O cartão final <strong>{cardNumber}</strong> será bloqueado e não poderá
        ser mais utilizado. Um novo cartão será gerado e entregue em até 5 dias
        úteis ao RH da sua empresa
      </Description>
    </>
  );
}

ConfirmBlock.propTypes = {
  cardNumber: PropTypes.string.isRequired,
};
